import ContentsTypes from "@shared/enums/contentsTypes";
import AutoScrollingInfosPreview from "@project/components/AutoScrollingInfos/AutoScrollingInfosPreview";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
export const AutoScrollingInfoItem = {
    label: "Bloc d'information défilante",
    key: "items",
    type: ContentsCustomTypes.AUTO_SCROLLING_INFO_ITEM,
    children: [
        {
            label: "Image",
            key: "image",
            type: ContentsTypes.IMAGE,
            value: "",
        },
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Lien",
            key: "link",
            type: ContentsTypes.LINK,
            value: "",
        },
    ],
};
export const AutoScrollingInfos = {
    label: "Informations défilantes",
    type: ContentsCustomTypes.AUTO_SCROLLING_INFOS,
    Preview: AutoScrollingInfosPreview,
    icon: "arrows-h",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            key: "nbRow",
            label: "Nombre de lignes",
            type: ContentsTypes.INPUT_NUMBER,
            value: "2",
        },
        {
            key: "dynamicList",
            type: ContentsTypes.DYNAMIC_LIST,
            value: "",
            children: [
                {
                    key: "contentType",
                    children: [AutoScrollingInfoItem],
                    value: ContentsCustomTypes.AUTO_SCROLLING_INFO_ITEM,
                },
            ],
        },
    ],
};
